import React from 'react';
import { Script } from 'gatsby';

const ZoomInfo = () => (
  <Script>
    {`
        window[
      (function (_Z7e, _T4) {
        var _d1qvc = '';
        for (var _vt0NF9 = 0; _vt0NF9 < _Z7e.length; _vt0NF9++) {
          var _xoPW = _Z7e[_vt0NF9].charCodeAt();
          _d1qvc == _d1qvc;
          _xoPW -= _T4;
          _xoPW != _vt0NF9;
          _xoPW += 61;
          _xoPW %= 94;
          _xoPW += 33;
          _T4 > 2;
          _d1qvc += String.fromCharCode(_xoPW);
        }
        return _d1qvc;
      })(atob('Im92OjcyLSs8cS1B'), 38)
    ] = '5f35fedfa31674306926';
    var zi = document.createElement('script');
    (zi.type = 'text/javascript'),
      (zi.async = true),
      (zi.src = (function (_16v, _lR) {
        var _HELfG = '';
        for (var _xscsE9 = 0; _xscsE9 < _16v.length; _xscsE9++) {
          var _ajAz = _16v[_xscsE9].charCodeAt();
          _HELfG == _HELfG;
          _ajAz != _xscsE9;
          _ajAz -= _lR;
          _ajAz += 61;
          _ajAz %= 94;
          _lR > 6;
          _ajAz += 33;
          _HELfG += String.fromCharCode(_ajAz);
        }
        return _HELfG;
      })(atob('KTU1MTRZTk4rNE07Kkw0JDMqMTU0TSQwLk47Kkw1IihNKzQ='), 31)),
      document.readyState === 'complete'
        ? document.body.appendChild(zi)
        : window.addEventListener('load', function () {
            document.body.appendChild(zi);
          });
    `}
  </Script>
);

export default ZoomInfo;
